import React from "react";
import DemoDoughnut from "../demo-doughnut";

const MarketOverview = ({
  donutIndenpendentMarketOpt,
  donutTotalMarketOpt,
}) => {
  const settings = {
    dots: true,
    infinite: true,
    vertical: false,
    verticalSwiping: false,
  };
  return (
    <div className='charts-container'>
      <div className='ind-market-div'>
        <p className='market-heading'>
          Independents Market Value <br />
          <span className='market-values'> £612.4m (+9.6%)</span>
        </p>

        <div
          style={{
            marginLeft: "-27.5px",
            marginRight: "-27.5px",
          }}
          id='m-overview'
        >
          <DemoDoughnut
            options={donutIndenpendentMarketOpt}
            title={"Household"}
            height={1000}
          />
          <div className='source-info'>
            <p className='info-p1'>
              Source: Nielsen & Circana - Impulse - Value Sales - MAT:
              September, October & November 2023
            </p>
          </div>
        </div>
      </div>
      <div className='total-market-div'>
        <p className='market-heading'>
          Total Market Value
          <br /> <span className='market-values'> £14.24bn (+7.9%)</span>
        </p>
        <div
          style={{ marginLeft: "-27.5px", marginRight: "-27.5px" }}
          id='m-overview'
        >
          <DemoDoughnut options={donutTotalMarketOpt} title={"Household"} />
          <div className='source-info'>
            <p className='info-p1'>
              Source: Nielsen & Circana - Total Market - Value Sales - MAT:
              September, October & November 2023
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketOverview;
